import I18n from 'components/I18n'
import Arrow, { ArrowSide } from 'components/Icons/Arrow'
import { OverlayLoader } from 'components/Loaders'
import { actions, selectors } from 'data'
import { StateType } from 'data/types'
import messages from 'lang'
import React, { useEffect } from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { connect, ConnectedProps } from 'react-redux'

import DataError from '../../../DataError'
import { Header, ModalTitle, Wrapper } from '../../styles'
import Instructions from './Instructions'

type Props = {
  children: React.ReactNode | undefined
  currency: string
  onBack: () => void
} & ConnectedProps<typeof connector> &
  WrappedComponentProps

const DepositInstructions = ({ accounts, children, currency, fetchAccount, onBack }: Props) => {
  useEffect(() => {
    if (!accounts || !accounts[currency]) {
      fetchAccount()
    }
  }, [currency])

  if (!accounts || !accounts[currency])
    return (
      <Wrapper>
        <OverlayLoader />
      </Wrapper>
    )

  const account = accounts[currency].value
  const { error } = accounts[currency]
  if (!account && error) {
    return <DataError error={error} />
  }

  if (!account)
    return (
      <Wrapper>
        <OverlayLoader />
      </Wrapper>
    )

  return (
    <Wrapper>
      <Header>
        <Arrow onClick={onBack} side={ArrowSide.LEFT} />
        <ModalTitle>
          <I18n
            data={currency === 'USD' ? messages.wire_instructions : messages.bank_instructions}
          />
        </ModalTitle>
      </Header>

      {children}

      <Instructions content={account.content} />
    </Wrapper>
  )
}
const mapStateToProps = (state: StateType) => ({
  accounts: selectors.payments.getAccounts(state)
})

const mapDispatchToProps = (dispatch, props) => ({
  fetchAccount: () => dispatch(actions.payments.fetchAccount(props.currency))
})

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(injectIntl(DepositInstructions))
